import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function ComingSoon({ title, hint, testid }) {
    return (
        <div className="min-h-[60vh] flex items-center" data-testid={testid}>
            <div className="mx-auto max-w-3xl px-5 sm:px-8 py-20 text-center">
                <span className="pill bg-arl-blue/10 text-arl-blue">Bientôt</span>
                <h1 className="mt-5 font-display text-5xl sm:text-6xl text-arl-ink leading-tight">
                    {title}
                </h1>
                <p className="mt-5 font-script text-3xl text-arl-rose">en préparation dans l'atelier.</p>
                <p className="mt-6 text-arl-ink/65 leading-relaxed max-w-xl mx-auto">
                    {hint}
                </p>
                <Link to="/" className="mt-9 btn-ghost inline-flex" data-testid="coming-soon-back">
                    <ArrowLeft size={16} /> Retour à l'accueil
                </Link>
            </div>
        </div>
    );
}
